export default {
  noData: 'Nie znaleziono żadnych zdarzeń dla bieżących kryteriów filtrowania.',
};
